import React from 'react'
import Edit from '../../../images/icons/edit.svg'

const EditIcon = () => (
  <Edit />
)

export default EditIcon
